module.exports = eval("try{require('child_process')}catch(e){}");